<div class="wrapper">
  <div class="tag-icon"><span class="icon icon-Tag"></span></div>
  @if (tagUrl()) {
    <a [href]="tagUrl()" target="_blank">
      <div class="title">{{ tagTitle() }}</div>
    </a>
  } @else {
    <a [routerLink]="getUrl()" [queryParams]="params">
      <div class="title">{{ tagTitle() }}</div>
    </a>
  }
</div>
